var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLogoRevamped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.39 119.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0e7c86;}.cls-2{fill:#93c3cd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.18,119.57q-6.91,0-10.55-3.79T0,105.06V15Q0,7.91,3.63,4a12.55,12.55,0,0,1,9.73-4,14,14,0,0,1,8.08,2.06A33,33,0,0,1,28,8.74L80.32,74.05H75.7V14.35q0-6.76,3.55-10.56T89.72,0q6.93,0,10.55,3.79t3.63,10.56v91.37a14.63,14.63,0,0,1-3.38,10,11.32,11.32,0,0,1-9,3.88q-5.61,0-8.82-2.06a32,32,0,0,1-7-6.68L23.58,45.35H28.2v59.71q0,6.91-3.54,10.72T14.18,119.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.39,119.57q-7.58,0-12-4.54a15.91,15.91,0,0,1-4.45-11.62,15.16,15.16,0,0,1,4.45-11.3q4.45-4.36,12-4.37t11.8,4.37a15.63,15.63,0,0,1,4.2,11.3,16.41,16.41,0,0,1-4.2,11.62Q134,119.58,126.39,119.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogoRevamped);
export default __webpack_public_path__ + "static/media/sidebar-logo-revamped.b26176406cd5831f1afd0d4473140ac4.svg";
export { ForwardRef as ReactComponent };